import { ITagProformated } from 'interfaces'

export const CONTENT_TYPE_TAG: ITagProformated[] = [
  { label: 'Advertising & Marketing', priority: 3 },
  { label: 'Agriculture', priority: 2 },
  { label: 'Aircraft & Boats', priority: 2 },
  { label: 'Armed Forces', priority: 2 },
  { label: 'Art & Photography', priority: 3 },
  { label: 'ASMR', priority: 3 },
  { label: 'Astrology', priority: 3 },
  { label: 'Auto', priority: 2 },
  { label: 'Beauty & Makeup', priority: 3 },
  { label: 'College, Sorority, & Fraternity', priority: 3 },
  { label: 'College Athlete', priority: 3 },
  { label: 'Comedy', priority: 3 },
  { label: 'Commercial & Industrial', priority: 2 },
  { label: 'Creativity & Leisure', priority: 3 },
  { label: 'Creator Education', priority: 3 },
  { label: 'DIY', priority: 3 },
  { label: 'Education', priority: 3 },
  { label: 'Entertainment', priority: 3 },
  { label: 'Entrepreneurship', priority: 3 },
  { label: 'Faith & Religion', priority: 3 },
  { label: 'Fashion & Style', priority: 3 },
  { label: 'Finance', priority: 3 },
  { label: 'Food & Drink', priority: 3 },
  { label: 'Gaming', priority: 3 },
  { label: 'Health & Fitness', priority: 2 },
  { label: 'Hotels & Hospitality', priority: 2 },
  { label: 'Home & Garden', priority: 2 },
  { label: 'Legal', priority: 2 },
  { label: 'Lifestyle', priority: 3 },
  { label: 'Mature Content', priority: 1 },
  { label: 'Medical & Health', priority: 3 },
  { label: 'MEME', priority: 1 },
  { label: 'Mind & Body', priority: 2 },
  { label: 'Movies, TV & Books', priority: 3 },
  { label: 'Music', priority: 3 },
  { label: 'News & Current Events', priority: 3 },
  { label: 'NSFW', priority: 1 },
  { label: 'Outdoors, Animals & Nature', priority: 3 },
  { label: 'Parenting & Family', priority: 3 },
  { label: 'Performance Art & Dance', priority: 3 },
  { label: 'Pets', priority: 3 },
  { label: 'Politics', priority: 3 },
  { label: 'Sports & Recreation', priority: 2 },
  { label: 'Teens', priority: 1 },
  { label: 'Travel', priority: 3 },
  { label: 'Real Estate', priority: 2 },
  { label: 'Science, Technology, & Engineering', priority: 3 },
  { label: 'Shopping & Retail', priority: 2 },
  { label: 'VR & Immersive Experiences', priority: 3 },
  { label: 'Web3, Crypto, NFTs', priority: 3 },
]

export const COLLAB_TYPES: string[] = [
  'Affiliate Promotions',
  'Ambassador or Sponsorship',
  'Amazon Affiliate',
  'Consulting',
  'Design',
  'Duet',
  'Edit',
  'Email List Promo',
  'Follower Swap',
  'Freelance',
  'Gifting',
  'Host & Co Host',
  'Instagram Post(s)',
  'Instagram Reel(s)',
  'Instagram Story',
  'In-Person',
  'Livestream',
  'NIL',
  'Podcast Promo',
  'Podcast Swap',
  'Product Trade',
  'Promo Swap',
  'Rate',
  'React',
  'Review',
  'Share',
  'Shoot',
  'Shoutout',
  'Social Sound Promo',
  'Star In',
  'Stream',
  'Stream Raid',
  'Stream & Co-Stream',
  'TikTok Livestream',
  'TikTok Post(s)',
  'TikTok Shop',
  'Tweet / Retweet',
  'UGC',
]

export const CREATOR_TYPES: string[] = [
  'A&R Manager',
  'Actor',
  'Analyst',
  'Animator',
  'Art Director',
  'Artist',
  'Athlete',
  'Author',
  'Brand Manager',
  'Business Manager',
  'Celebrity',
  'Channel Manager',
  'Channel/Stream Moderator',
  'Chef',
  'Coach',
  'Composer',
  'Consultant',
  'Copywriter',
  'Creator',
  'Director',
  'Editor',
  'Educator',
  'Engineer',
  'Entrepreneur',
  'Events Planner/Coordinator',
  'Finance Professional',
  'Founder',
  'Illustrator & Graphic Designer',
  'Influencer Marketer',
  'Influencer',
  'Investor',
  'Journalist',
  'Legal Team Member',
  'Make Up Artist',
  'Marketing Professional',
  'Model',
  'Moderator',
  'Motion Designer',
  'Musician',
  'Photographer',
  'Podcaster',
  'Producer',
  'Product Manager',
  'Professional Athlete',
  'Social Media Manager',
  'Song Writer',
  'Sound Engineer',
  'Streamer',
  'Talent Manager',
  'Technician',
  'Ui/Ux Designer',
  'Videographer',
  'Writer',
  'YouTuber',
]
